var HtmlComponent_default = {
  "htmlComponent": "lzRFc",
  "htmlComponent_placeholder": "Yy-Uk"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
